// Single source of truth for calendar-specific colors. Imported by tailwind.config.js
// (to expose `bg-calendar-*` / `.calendar-unavailable` utilities) and directly by
// DayTimeGrid.vue, which needs the raw values to build a composited inline `background`
// shorthand (per-teacher gradient stripe + solid fill) that a Tailwind class can't express.
export const calendarColors = {
  bg:      '#f3f4f5',
  bgDark:  '#111110',

  cardNeutral:     '#fdfeff',
  cardNeutralDark: 'rgba(55,65,81,0.6)',

  unavailable:            '#f1f2f3',
  unavailableDark:        'rgba(0,0,0,0.35)',
  unavailableStripe:      '#e4e5ec',
  unavailableStripeDark:  'rgba(255,255,255,0.06)',

  // Marked time off — deliberately bolder/warmer than the neutral "outside working
  // hours" shading above, so the two are never confused at a glance.
  timeoff:            'rgba(245,158,11,0.16)',
  timeoffDark:         'rgba(245,158,11,0.14)',
  timeoffStripe:       'rgba(217,119,6,0.35)',
  timeoffStripeDark:   'rgba(251,191,36,0.30)',
}
